import { IAdspace, TAdspaceList } from 'entities/Adspace';
import { commonApi } from 'shared/api/commonApi';
import { EApiTags } from 'shared/typings';

export const adspaceApi = commonApi
	.injectEndpoints({
		endpoints: (builder) => ({
			getAdspace: builder.query<IAdspace, string>({
				query: (uuid) => ({
					url: `adspaces/${uuid}/`,
				}),
			}),
			getAdspaceList: builder.query<TAdspaceList, string>({
				query: (params) => ({
					url: `adspaces/${params ? '?' : ''}${params}`,
				}),
			}),
		}),
		overrideExisting: false,
	})
	.enhanceEndpoints({
		addTagTypes: [EApiTags.ADSPACES_LIST],
		endpoints: {
			getAdspaceList: {
				providesTags: [EApiTags.ADSPACES_LIST],
			},
		},
	});

export const { useGetAdspaceQuery, useGetAdspaceListQuery } = adspaceApi;
